'use strict';
angular.module('initiWoDataModule', []).factory('initiWoDataService', [
    '$state',
    function($state) {
        return {
            initNews: function() {
                var list = {
                    METADATAID: 0,
                    TITLE: '',
                    SUBTITLE: '',
                    LEADTITLE: '',
                    CONTENT: '',
                    NEWSSOURCES: '',
                    SIGNATUREAUTHOR: '',
                    KEYWORDS: '',
                    ABSTRACT: '',
                    DOCGENRE: '',
                    HTMLCONTENT: '',
                    DOCWORDSCOUNT: 0,
                    ISNOPAYMENT: '1',
                    REMARKS: '',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    ORIGINAL: '0',
                    VIDEOREL: [], // 编辑器插入视频
                    MEDIATYPES: '0',
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                };
                return list;
            },
            initAtlas: function() {
                var list = {
                    METADATAID: 0,
                    TITLE: '',
                    SUBTITLE: '',
                    LEADTITLE: '',
                    NEWSSOURCES: '',
                    SIGNATUREAUTHOR: '',
                    CONTRIBUTORS: '',
                    KEYWORDS: '',
                    CONABSTRACT: '',
                    DOCGENRE: '',
                    ISNOPAYMENT: '1',
                    DOC_PICTURELIST: [],
                    SOURCEMETAID: '',
                    FLOWVERSIONTIME: '',
                    REMARKS: '',
                    DOCWORDSCOUNT: 0,
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    ORIGINAL: '0',
                    HTMLCONTENT: '',
                    CONTENT: '',
                    VIDEOREL: [],
                    MEDIATYPES: '0',
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                };
                return list;
            },
            initLink: function() {
                var list = {
                    METADATAID: 0,
                    TITLE: '',
                    NEWSSOURCES: '',
                    SIGNATUREAUTHOR: '',
                    CONTRIBUTORS: '',
                    KEYWORDS: '',
                    CONABSTRACT: '',
                    SOURCEMETAID: '',
                    FLOWVERSIONTIME: '',
                    URL: '',
                    DOCWORDSCOUNT: 0,
                    ORIGINAL: '0',
                    HTMLCONTENT: '',
                    CONTENT: '',
                    VIDEOREL: [],
                    MEDIATYPES: '0',
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    DOCGENRE: '',
                    ISNOPAYMENT: '1',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                };
                return list;
            },
            initVideo: function() {
                var list = {
                    METADATAID: 0,
                    THUMB: 1,
                    VIDEOID: '',
                    TITLE: '',
                    HTMLCONTENT: '',
                    CONTENT: '',
                    NEWSSOURCES: '',
                    SIGNATUREAUTHOR: '',
                    URL: '',
                    ISNOPAYMENT: '1',
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    DOCGENRE: '',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    TOPICCOMPERE: '',
                    VIDEOREL: [],
                };
                return list;
            },
            initManuscript: function() {
                var list = {
                    METADATAID: 0,
                    SOURCEDOCID: 0,
                    TITLE: '',
                    DOCWORDSCOUNT: '',
                    ISCONTAINSENSITIVEWORDS: 0,
                    CONTENT: '',
                    HTMLCONTENT: '',
                    CONTENTSTRUCTURE: '',
                    SPEECHRATE: '1',
                    CONTENTDURATION: '00:00:00',
                    INTRODUCERDURATION: '00:00:00',
                    EDITINGDURATION: '00:00:00',
                    TOTALDURATION: '00:00:00',
                    BROADCASTING: '',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    EXATTRIBUTE: [],
                    CORRESPONDENT: '',
                    SUBTITLEWORDS: '',
                    THEMEFLOWER: '',
                    BROADCASTINGNAME: '',
                };
                return list;
            },
            initPlannedOrder: function() {
                var list = {
                    METADATAID: 0,
                    SOURCEDOCID: 0,
                    QUOTECHNLID: 0,
                    PREDATE: '',
                    DUTYOFFICER: '',
                    GUIDEDBROADCAST: '',
                    HOSTER: '',
                };
                return list;
            },
        };
    },
]);
